import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const STEPS = [
  {
    num: "01",
    title: "Tell Us About Your Celebration",
    copy: "Complete the inquiry form with your event date, cake size, flavors, design ideas, and inspiration.",
  },
  {
    num: "02",
    title: "We Create Your Custom Quote",
    copy: "We\u2019ll review your request, confirm availability, discuss the design, and provide your final quote.",
  },
  {
    num: "03",
    title: "Your Cake Comes to Life",
    copy: "Once everything is approved, Bella Bells Cakes will create a custom dessert designed especially for your celebration.",
  },
];

const Process = () => (
  <section id="process" className="scroll-mt-24 py-24 sm:py-32" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="05" label="How It Works" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 max-w-xl font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
          From idea to first slice
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.15} className={i === 1 ? "md:mt-12" : i === 2 ? "md:mt-24" : ""}>
            <div data-testid={`process-step-${s.num}`} className="border-t border-[#2D2422]/15 pt-8">
              <span className="font-display text-6xl font-light italic text-[#E8D8D3]">{s.num}</span>
              <h3 className="mt-5 font-display text-2xl font-normal leading-snug text-[#2D2422]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5C4B47]">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3} className="mt-16">
        <button onClick={() => scrollToId("#inquiry")} className="btn-primary" data-testid="process-cta">
          Request Your Cake <ArrowRight size={16} strokeWidth={1.5} />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Process;
